import Route from 'mewe/routes/route';

import { Theme } from 'mewe/constants';
import { fetchFeedPage, getPageFeed } from 'mewe/fetchers/fetch-feed';
import { ds } from 'mewe/stores/ds';

export const PageFeedRouteBase = Route.extend({
  queryParams: {
    tag: {
      refreshModel: true,
    },
  },

  theme: Theme.PAGE,

  id() {
    return this.modelFor('app.publicid').page.id;
  },

  beforeModel: function (transition) {
    let { to: toRouteInfo } = transition;

    let id = this.id();

    this.tag = toRouteInfo.queryParams.tag || null;

    fetchFeedPage(id, { hashtag: this.tag });

    this.dispatch('feed', 'dismissWrappers', { pageIds: [this.id()] }, true);
  },

  model(params) {
    let model = this.modelFor('app.publicid');

    if (model && model.setProperties)
      model.setProperties({
        feed: getPageFeed(this.id(), { hashtag: params.tag }),
        notifications: ds.notifications.for(this.id()),
        tag: this.tag,
      });

    return model;
  },

  actions: {
    willTransition(transition) {
      let { to: toRouteInfo } = transition;

      // checking tag stored in 'this' instead controller to avoid some problems (SG-16051)
      if (this.tag) {
        this.controller.set(
          'tag',
          toRouteInfo.queryParams && toRouteInfo.queryParams.tag ? toRouteInfo.queryParams.tag : null
        );
        history.replaceState('', document.title, window.location.pathname); // prevent loading feed for tag on back navigation
      }

      if (toRouteInfo.queryParams && toRouteInfo.queryParams.tag) window.scrollTo(0, 350);
    },

    refreshFeed() {
      fetchFeedPage(this.id());
      this.dispatch('feed', 'dismissWrappers', { pageIds: [this.id()] });
    },

    didTransition() {
      window.scrollTo(0, 0);
    },
  },
});

export default PageFeedRouteBase;
